export default __webpack_public_path__ + "static/media/icon.22d061c5.png";